export default __webpack_public_path__ + "static/media/bg-middle.fee143ef.png";